import { IWeightingBarStyle } from '../models/index.js';
export const weightingBarStyle: IWeightingBarStyle = {
	children: {
		weightingBlock: {
			display: 'inline-block',
			padding: {
				_value: '10px 20px',
			},
		},
	},
};
